var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurvedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 306,
    height: 204,
    viewBox: "0 0 306 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.5408C43.3704 7.6471 218.299 -18.9214 218.299 44.4939C192.043 82.6065 132.196 83.6565 104.754 76.6168C68.1604 67.2294 127.214 45.8025 152.123 42.8858C217.741 35.2022 280.308 55.9067 296.775 86.3769C310.604 111.965 299.422 140.02 282.48 164.269C274.533 175.644 258.604 183.41 249.806 194.13C236.196 210.715 269.538 192.565 286.273 188.6C320.466 180.499 264.191 192.722 252.432 195.552C233.03 200.222 224.69 171.808 218.299 161.425",
    stroke: "#6578BD",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedArrow);
export default __webpack_public_path__ + "static/media/curved-arrow.869e5d310c5df2c9c553bf45f108c203.svg";
export { ForwardRef as ReactComponent };